import { Container } from "@mui/material";
import React from "react";
import Successmark from "../../../assets/images/Successmark.png";
import {
  PendingApprovalMain,
  PendingImg,
  PendingText,
} from "../../../components/customer/auth/styles/ProfilePasswordChangeStyle";

const LinkExpiredPage = () => {
  return (
    <>
      <Container maxWidth="lg">
        <PendingApprovalMain>
          <PendingImg>
            <img src={Successmark} alt="Successmark" />
          </PendingImg>
          <PendingText>
            <h6>Link Expired!</h6>
            <p>Please create your link again.</p>
          </PendingText>
        </PendingApprovalMain>
      </Container>
    </>
  );
};

export default LinkExpiredPage;
